export const API_BASE_DOMAIN =
  import.meta.env.VITE_API_BASE_DOMAIN || "api.teamfence.io";
export const API_BASE_PROTOCOL =
  import.meta.env.VITE_API_BASE_PROTOCOL || "https";
export const API_BASE_WS_PROTOCOL =
  import.meta.env.VITE_API_BASE_WS_PROTOCOL || "wss";

const IS_LOCAL_API = API_BASE_DOMAIN.includes("localhost");
const USE_PROXY = import.meta.env.DEV && !IS_LOCAL_API;

export const API_BASE_PATH = USE_PROXY
  ? "/api"
  : API_BASE_PROTOCOL + "://" + API_BASE_DOMAIN;

export const ACCESS_TOKEN_KEY = "accessTokenKey";
export const REFRESH_TOKEN_KEY = "refreshTokenKey";
export const SELECTED_MEMBERSHIP_KEY = "selectedMembershipId";
export const VIEW_AS_STANDARD_KEY = "viewAsStandard";
export const THEME_KEY = "theme";
export const TOUR_COMPLETED_KEY = "dashboardTourCompleted";
export const LAST_CHAT_CONVERSATION_KEY = "lastChatConversation";

export const TERMS_VERSION = "2025-03-11";

// Every user belongs to this group. The API doesn't flag it, so it is
// recognised by name; its members can't be removed and it can't be edited.
export const DEFAULT_GROUP_NAME = "All Users";
// Public trial request form. Behind the `VITE_FEATURE_TRIAL` flag, which also
// gates the two pages below.
export const TRIAL_ROUTE = "/trial";
// Confirms a trial request's email (`?t=<token>`, the confirmation link).
// The backend builds it from its `TRIAL_REQUEST_CONFIRM_FE_BASE_URL`: keep in sync.
export const TRIAL_CONFIRM_ROUTE = "/trial/confirm";
// Set-up wizard of an approved trial request (`?t=<token>`, the approval
// email's link). Built from the backend's `TRIAL_SETUP_FE_BASE_URL`.
export const TRIAL_SETUP_ROUTE = "/trial/setup";

// Awareness page of the simulation emails: their link redirects here with a
// handoff code in the fragment (`#code=<code>`). The simulation service builds
// it from its `AWARENESS_PAGE_URL`: keep in sync.
export const AWARENESS_ROUTE = "/awareness";

// Privacy notice shown with the trial request; its version is sent along.
export const PRIVACY_NOTICE_URL: string =
  import.meta.env.VITE_PRIVACY_NOTICE_URL || "";
export const PRIVACY_NOTICE_VERSION: string =
  import.meta.env.VITE_PRIVACY_NOTICE_VERSION || "2026-10";
// "Contact us" on the trial pages (a page or a mailto: link). Empty: hidden.
export const CONTACT_URL: string = import.meta.env.VITE_CONTACT_URL || "";

// Cloudflare Turnstile site key for the public forms (login, password reset,
// account activation, trial request and set-up). Empty: no widget (only
// works against a backend with the bot check disabled). Locally, the always
// passing test key `1x00000000000000000000AA`.
export const TURNSTILE_SITE_KEY: string =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || "";
